export const styles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(17, 24, 39, 0.55)',
    zIndex: 10003,
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  modal: {
    width: 'min(1400px, 100%)',
    height: 'min(92vh, 900px)',
    background: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    boxShadow: '0 28px 80px rgba(0,0,0,0.22)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  header: {
    padding: '16px 18px',
    borderBottom: '1px solid #E5E7EB',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
  },
  headerLeft: { minWidth: 0 },
  titleLine: { display: 'flex', alignItems: 'center', gap: 8 },
  metaLine: {
    marginTop: 6,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    color: '#6B7280',
    fontSize: 12,
  },
  metaItem: { display: 'inline-flex', alignItems: 'center', gap: 6 },
  metaIcon: { fontSize: 16, color: '#9CA3AF' },
  metaStrong: { color: '#374151' },

  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: 10,
    border: '1px solid transparent',
    background: 'transparent',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  topBar: {
    padding: '12px 18px',
    borderBottom: '1px solid #E5E7EB',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },

  searchWrap: {
    flex: 1,
    minWidth: 260,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    padding: '8px 10px',
    background: '#FFFFFF',
  },
  searchInput: {
    width: '100%',
    border: 0,
    outline: 0,
    fontSize: 13,
    color: '#111827',
    background: 'transparent',
  },

  topActions: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
  linkBtn: {
    border: 0,
    background: 'transparent',
    color: '#111827',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 13,
    padding: '6px 8px',
    borderRadius: 8,
    opacity: 1,
  },

  content: {
    padding: 18,
    overflow: 'auto',
    flex: 1,
    background: '#F9FAFB',
  },

  block: {
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    marginBottom: 12,
    overflow: 'hidden',
  },
  blockHeader: {
    width: '100%',
    border: 0,
    background: '#FFFFFF',
    cursor: 'pointer',
    padding: '14px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    textAlign: 'left',
  },
  qTitle: { fontSize: 13, fontWeight: 900, color: '#111827' },
  qSub: { marginTop: 4, fontSize: 12, color: '#6B7280' },

  questionDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#E5E7EB',
    marginTop: 10,
  },

  expandPill: {
    flexShrink: 0,
    fontSize: 12,
    fontWeight: 900,
    color: '#111827',
    background: '#F3F4F6',
    borderRadius: 999,
    padding: '6px 10px',
  },

  blockBody: {
    padding: 14,
    borderTop: '1px solid #E5E7EB',
    background: '#FFFFFF',
  },

  card: {
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    padding: 12,
    background: '#FFFFFF',
    minWidth: 0,
  },

  sectionTitle: { fontSize: 12, fontWeight: 900, color: '#374151', marginBottom: 8 },

  answerRow: {
    width: '100%',
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    borderRadius: 10,
    padding: '10px 12px',
    fontSize: 13,
    fontWeight: 800,
    color: '#111827',
  },

  qNumber: {
    width: 24,
    height: 24,
    borderRadius: 999,
    background: '#EEF2F7',
    border: '1px solid #E5E7EB',
    color: '#111827',
    fontSize: 12,
    fontWeight: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  textBox: {
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    borderRadius: 10,
    padding: 12,
    fontSize: 13,
    color: '#111827',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    maxWidth: '100%',
  },

  emptyAnswer: {
    padding: 12,
    borderRadius: 10,
    border: '1px dashed #E5E7EB',
    background: '#F9FAFB',
  },

  center: {
    padding: 30,
    textAlign: 'center',
  },

  footer: {
    padding: 12,
    borderTop: '1px solid #E5E7EB',
    display: 'flex',
    justifyContent: 'flex-end',
    background: '#FFFFFF',
  },

  mediaGridWrap: { width: '100%' },

  mediaGrid: {
    display: 'grid',
    gap: 10,
    width: '100%',
    alignItems: 'start',
  },

  mediaImgTile: {
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
    padding: 0,
    outline: 'none',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },

  mediaOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'rgba(17, 24, 39, 0.22)',
    transition: 'opacity 120ms ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  mediaOverlayBtn: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: 'rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid rgba(255,255,255,0.25)',
  },

  mediaNameBelow: {
    position: 'absolute',
    left: 8,
    right: 8,
    bottom: 8,
    fontSize: 11,
    fontWeight: 900,
    color: '#111827',
    background: 'rgba(255,255,255,0.92)',
    borderRadius: 10,
    padding: '6px 8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  mediaDocBtn: {
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    background: '#FFFFFF',
    cursor: 'pointer',
    width: '100%',
    padding: 10,
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    textAlign: 'left',
    minWidth: 0,
  },

  mediaDocTile: {
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    background: '#FFFFFF',
    width: '100%',
    padding: 10,
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    minWidth: 0,
  },

  mediaDocIconWrap: {
    width: 34,
    height: 34,
    borderRadius: 12,
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  mediaName: {
    fontSize: 12,
    fontWeight: 800,
    color: '#111827',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },

  lightboxIconBtn: {
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    padding: 6,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  exportBtn: {
    background: '#F3F4F6',
    color: '#374151',
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    padding: '10px 18px',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 150ms ease',
    flexShrink: 0,
  },

  exportSingleResponseContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    gap: '1rem',
  },
};

